import { MutableRefObject, useCallback, useRef } from 'react';

export function useDebounce<Args extends unknown[]>(callback: (...args: Args) => void, delay: number) {
  const timer = useRef() as MutableRefObject<ReturnType<typeof setTimeout>>;

  return useCallback(
    (...args: Args) => {
      if (timer.current) {
        clearTimeout(timer.current);
      }

      timer.current = setTimeout(() => {
        callback(...args);
      }, delay);
    },
    [callback, delay]
  );
}
